// extracted by mini-css-extract-plugin
export var dividerContainer = "_69-0";
export var line = "_69-1";